'use client'

import React from 'react'
import { Box, Flex, Portal } from '@mantine/core'
import type { Sku } from '@/types/interfaces/sku'
import { SkuDetailCta } from '@/components/SkuDetailCta'

export function SkuStickyCta({ sku, variant = 'refresh' }: { sku: Sku; variant?: 'refresh' | 'legacy' }) {
    return (
        <Portal>
            <Box hiddenFrom="md" pos="fixed" left={0} right={0} bottom={0} style={{ zIndex: 190 }}>
                <Flex
                    justify="center"
                    bg="var(--Background-bg-card, #FAF7F5)"
                    bd="1px solid var(--Foreground-fg-outline-primary, #D1D0CF)"
                    px={24}
                    pt={24}
                    style={{
                        borderTopLeftRadius: 24,
                        borderTopRightRadius: 24,
                        boxShadow: '0 0 5px 0 rgba(64, 63, 62, 0.05), 0 -10px 10px 0 rgba(64, 63, 62, 0.05)',
                        paddingBottom: 'calc(24px + env(safe-area-inset-bottom, 0px))',
                    }}
                >
                    <SkuDetailCta sku={sku} skuPageVariant={variant} style={{ width: '100%', maxWidth: '100%' }} />
                </Flex>
            </Box>
        </Portal>
    )
}
